import { HttpClient } from '@angular/common/http';
import { Component, OnInit,EventEmitter, Output, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigurationService } from '@app/_services/configuration.service';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import {
  PublicClientApplication,
  InteractionStatus,
} from '@azure/msal-browser';
import { stringify } from 'ajv';
import { filter } from 'rxjs/operators';

declare const gapi: any;
declare const google: any;
@Component({
  selector: 'kupari-oauth',
  templateUrl: './oauth.component.html',
  styleUrls: ['./oauth.component.scss'],
})
export class OAuthComponent implements OnInit {
  private googleAuthInstance: any;
  private msalInstance: PublicClientApplication;
  private tokenClient: any;
  @Input() type: string = "ANY";
  @Input() loggedIn: string = "";
  @Input() redirectParams: any;
  @Output() onAuth: EventEmitter<any> = new EventEmitter<any>();
  @Output() onLogout: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private msalService: MsalService,
    private router: Router,
    private route: ActivatedRoute,
    private configuration: ConfigurationService,
    private http: HttpClient,
  ) {}

  ngOnInit() {

    if(this.type == "ANY" || this.type == "MICROSOFT")
      this.initializeMicrosoftAuth();
    if(this.type == "ANY" || this.type == "GOOGLE"){
      console.log("Type Google");
    this.loadGapiScript().then(() => {
        console.log("Ahaaa");
      this.initializeGoogleLogin();
    }).catch(error => {
      console.error('Error loading Google API script', error);
    });
    }
  }

loadGapiScript(): Promise<void> {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject('Google API script failed to load');
    document.body.appendChild(script);
  });
}
  // GoogleAuth-initialisointi
  initializeGoogleAuth() {
    console.log("initialize")
    gapi.load('auth2', () => {
      gapi.auth2.init({
        client_id: '83217889293-fmnn9td3d4komn44dmgke5td96d1pmcv.apps.googleusercontent.com',
        scope: 'https://www.googleapis.com/auth/gmail.readonly',
        redirect_uri: window.location.origin + "/oauth?" + this.redirectParams,
        access_type: 'offline' // Tämän avulla saadaan refresh token
      }).then(() =>{
          console.log("then");
        this.googleAuthInstance = gapi.auth2.getAuthInstance();
      }).catch((err:any) => {
          console.error("ERROR", err);
      });
      console.log(this.googleAuthInstance);
      //
      // // Tarkista, onko käyttäjä jo kirjautuneena Googlen kautta
      // if (this.googleAuthInstance.isSignedIn.get()) {
      //   console.log("watafaaa");
      //   const user = this.googleAuthInstance.currentUser.get();
      //   console.log(user);
      //   this.handleGoogleSignInSuccess(user);
      // }
    });
  }

  // MicrosoftAuth-initialisointi
  initializeMicrosoftAuth() {

    this.route.queryParams.subscribe(x => {
      if(x["code"]){
          const redirectParams = JSON.parse(sessionStorage.getItem("redirectParams"));
          const codeVerifier = sessionStorage.getItem("code_verifier");
            this.http.post(this.configuration.apiUrl + '/interface/email/microsoft/oauth', { code: x["code"], redirectUri: window.origin + '/oauth', codeVerifier: codeVerifier, returnUrl: window.origin + redirectParams.returnUrl, interfaceId:redirectParams.interfaceId}).subscribe(x => {
              console.log(x);
              sessionStorage.setItem("microsoftToken", JSON.stringify(x));
              this.router.navigate([redirectParams.returnUrl]);
            })
      }
    })
    this.storeAuthorizationCode();
    this.msalService.instance.initialize().then(() => {
      // this.msalService.instance.handleRedirectPromise().then((response) => {
      //   console.log(response);
      //   console.log(window.location.hash);
      //   if(response){
      //     console.log(response);
      //     const state = response.state ? JSON.parse(response.state) : null;
      //     if(state && state.returnUrl){
      //       this.router.navigate([state.returnUrl]);
      //     }
      //   }
      // })
    }).catch((err: any) => {
        console.log(err);
      })
    //
    // this.msalBroadcastService.inProgress$
    //   .pipe(
    //     filter(
    //       (status: InteractionStatus) => status === InteractionStatus.None,
    //     ),
    //   )
    //   .subscribe(() => {
    //     const account = this.msalService.instance.getActiveAccount();
    //     if (account) {
    //       this.handleMicrosoftSignInSuccess(account);
    //     }
    //   });
  }

  // Alusta Google Login Button
  initializeGoogleLogin() {
    this.tokenClient = google.accounts.oauth2.initCodeClient({
      client_id: '83217889293-fmnn9td3d4komn44dmgke5td96d1pmcv.apps.googleusercontent.com',
      scope: 'https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/gmail.readonly', // Pyydä Gmail-oikeudet
      access_type: "offline",
      prompt: 'consent', // Varmistaa, että käyttäjältä kysytään lupaa sähköpostin käyttöön
      callback: (response: any) => {
        if (response.error) {
          console.error('Error retrieving authorization code:', response);
          return;
        }
        console.log('Authorization Code:', response.code);
    try {
        this.onAuth.emit({
          type:'google',
          response: response
        });
    } catch(error: any){
      console.log(error);
    }

      }
    });

    // Lisää login-painike
    // google.accounts.oauth2.renderButton(
    //   document.getElementById("buttonDiv"), // Elementti, johon painike sijoitetaan
    //   { theme: "outline", size: "large" }  // Painikkeen asetukset
    // );
  }

  handleCredentialResponse(response: any) {
        // Lähetä authorization code backendille
  }
  // Google-kirjautuminen
  loginWithGoogle() {
    this.tokenClient.requestCode();
    // this.googleAuthInstance
    //   .signIn()
    //   .then((user: any) => {
    //     console.log(user);
    //     this.handleGoogleSignInSuccess(user);
    //   })
    //   .catch((error: any) => {
    //     console.error('Google sign-in error:', error);
    //   });
  }

  // Microsoft-kirjautuminen
  loginWithMicrosoft() {
    this.startLoginFlow()
      .then((response) => { console.log(response)})
      .catch((err) => console.log(err));
    // // this.msalInstance
    // console.log(this.redirectParams);
    // this.msalService.instance
    //   .loginRedirect({
    //     redirectUri: window.location.origin + "/oauth",
    //     state: JSON.stringify(this.redirectParams),
    //     scopes: ['Mail.Read','User.Read','offline_access'],
    //   }).then(response => {
    //     console.log(response);
    //     console.log("AHAHA");
    //     console.log(this.msalService.instance.getAllAccounts()[0]);
    //     this.onAuth.emit({
    //       type:'microsoft',
    //       response: this.getAndRemoveAuthorizationCode()
    //     });
    //   }).catch(error => {
    //       console.error('Microsoft sign-in error:', error);
    //   })
  }

  // Google kirjautumisen käsittely
  handleGoogleSignInSuccess(googleUser: any) {
    const profile = googleUser.getBasicProfile();
    console.log('Google User: ', profile.getName(), profile.getEmail());
  }

  // Microsoft kirjautumisen käsittely
  handleMicrosoftSignInSuccess(account: any) {
    console.log('Microsoft User: ', account.name, account.username);
  }

  // Kirjautuminen ulos molemmista
  logout() {
    // Kirjaa ulos molemmista palveluista
    if(this.type == 'GOOGLE')
      this.onLogout.emit(null);
      // this.googleAuthInstance.signOut().then(() => {
      //   console.log('Logged out from Google.');
      // });

    if(this.type == 'MICROSOFT')
    this.msalService.logoutPopup().subscribe((x) => {
      console.log('Logged out from Microsoft.');
    });
  }

  // 1. Metodi hakee authorization code:n ja state-parametrin hashistä ja tallentaa code:n localStorageen
  storeAuthorizationCode(): void {
    const fragment = window.location.hash;
    if (fragment && fragment.includes('code=')) {
      const code = this.getQueryParamFromFragment(fragment, 'code');
      const state = this.getQueryParamFromFragment(fragment, 'state');
      if (code) {
        localStorage.setItem('authorization_code', code);
        console.log('Authorization code stored in localStorage:', code);

        // Optionaalisesti voit poistaa hash-osan URL:sta
        window.location.hash = ''; // Tyhjentää URL:n hashin

        // Käsittele state-parametri ja sen sisällä oleva returnUrl
        if (state) {
          const [base64Part, jsonPart] = state.split('|'); // Erotetaan base64- ja JSON-osa
          try {
            console.log(base64Part, jsonPart);
            const parsedState = JSON.parse(jsonPart); // Jäsennetään JSON-osa
            const interfaceId = parsedState.interfaceId || '/'; // Oletuksena '/' jos ei ole returnUrl:ia
            const returnUrl = parsedState.returnUrl || '/'; // Oletuksena '/' jos ei ole returnUrl:ia
          } catch (error) {
            console.error('Invalid state parameter JSON part:', error);
          }
        }
      }
    }
  }

  // 2. Metodi hakee authorization code:n localStoragesta ja poistaa sen
  getAndRemoveAuthorizationCode(): string | null {
    const code = localStorage.getItem('authorization_code');
    if (code) {
      localStorage.removeItem('authorization_code');
      console.log('Authorization code retrieved and removed from localStorage:', code);
    }
    return code;
  }

  // Apumetodi parametrien hakemiseen hashistä
  private getQueryParamFromFragment(fragment: string, param: string): string | null {
    const params = new URLSearchParams(fragment.substring(1)); // Poistetaan hash (#)
    return params.get(param);
  }
generateCodeVerifier(): string {
  const randomArray = new Uint8Array(32);
  window.crypto.getRandomValues(randomArray);
  return this.base64UrlEncode(randomArray);
}

base64UrlEncode(buffer: Uint8Array): string {
  return btoa(String.fromCharCode.apply(null, buffer as any))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}
  async generateCodeChallenge(codeVerifier: string): Promise<string> {
  const encoder = new TextEncoder();
  const data = encoder.encode(codeVerifier);
  const hashBuffer = await window.crypto.subtle.digest('SHA-256', data);
  const hashArray = new Uint8Array(hashBuffer);
  return this.base64UrlEncode(hashArray);
}
async startLoginFlow() {
  const codeVerifier = this.generateCodeVerifier(); // Generoi code_verifier
  const codeChallenge = await this.generateCodeChallenge(codeVerifier); // Laske code_challenge

  // Tallenna code_verifier myöhempää käyttöä varten
  sessionStorage.setItem('code_verifier', codeVerifier);
  sessionStorage.setItem('redirectParams', JSON.stringify(this.redirectParams));

  // Käynnistä kirjautumisprosessi, lähetä code_challenge osana pyyntöä
  const authorizationUrl = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?` +
    `client_id=8e53b699-da2f-45f3-af9c-e2f57247eb1f&response_type=code&redirect_uri=${encodeURIComponent('http://localhost:4200/oauth')}` +
    `&scope=${encodeURIComponent('openid profile offline_access User.Read Mail.Read')}&code_challenge=${codeChallenge}&code_challenge_method=S256`;

  // Suorita uudelleenohjaus
  window.location.href = authorizationUrl;
}
}
